import './App.css';

import Navbar from './components/Navbar';
// import FloatingSidebar from './components/FloatingSidebar';
import Footer from './components/Footer';

import Header from './components/Header';
import Master from './components/Master';
import StudyMethod from './components/StudyMethod';
import Memberships from './components/Memberships';
import Financing from "./components/Financing"
import Counseling from './components/Counseling';
import FeaturedResults from './components/FeaturedResults';
import FAQ from './components/FAQ';


function App() {
  return (
    <main className="App">
      <Navbar />
      {/* <FloatingSidebar /> */}
      <Header />
      <Master />
      <StudyMethod />
      <Memberships />
      <Financing />
      <Counseling />
      <FeaturedResults />
      <FAQ />
      <Footer />
    </main>
  );
}

export default App;
